import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Search } from "lucide-react";
import { searchBfLeads } from "@/lib/bf";

export default function BFClientFind() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => searchBfLeads(q).then(setRows).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <section className="invite-box" data-testid="bf-client-find">
      <h3>Deschide fișa unui salon</h3>
      <p className="st-hint">Vezi și completezi fișa oricărui salon. Agenții o deschid din „Planificarea mea → Fișe clienți”, doar pentru saloanele lor.</p>
      <label className="bf-stock-search"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută salonul: denumire, nume, telefon, CUI, oraș" data-testid="bf-client-find-search" /></label>
      <ul className="bf-smove-list" style={{ marginTop: 10 }}>
        {rows.map((r) => (
          <li key={r.id}><Link to={`/client/${r.id}`} className="bf-client-find-row" data-testid={`bf-client-find-${r.id}`}>
            <ClipboardList size={15} /><b>{r.salon || "Salon"}</b><small>{[r.admin_name, r.phone, r.city, r.cui && `CUI ${r.cui}`].filter(Boolean).join(" · ")}</small>
          </Link></li>
        ))}
      </ul>
      {q.trim().length >= 2 && !rows.length && <p className="st-hint" data-testid="bf-client-find-none">Niciun salon găsit.</p>}
    </section>
  );
}
